
const GhostRoutes = [
  {
    path: "/ghost_exec/:id",
    name: "Execução Anônima",
    component: () => import("./pages/GhostExecution.vue"),
    meta: {
      auth: false,
    },
  },
  {
    path: "/ghost_done_exec",
    name: "Resultado anônimo",
    // component: () => import("./pages/GhostDone.vue"),
    meta: {
      // auth: false,
    },
  },
];

export default GhostRoutes;